import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@totalsoft/rocket-ui';

function HeaderTitle() {
  const { t } = useTranslation();
  return (
    <Typography noWrap variant='subtitle1' fontWeight='bold' sx={{ pr: 0.5 }}>
      {t('Dashboard.RequiredDocuments.Text')}
    </Typography>
  );
}

export default HeaderTitle;
